import React, { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import { MemberIcon } from "../../constants/MemberIcon";
import ChangeRequestMeta from "../../Components/casp/ChangeRequestUpdate/changeRequestMeta";
import ChangeRequestAccordion from "../../Components/casp/ChangeRequestUpdate/accordion";
import SweetAlert from "react-bootstrap-sweetalert";
import { toast } from "react-toastify";
import Button from "@mui/material/Button";
import { Spinner } from "reactstrap";
import {
  changeRequestItemCreate,
  changeRequestItemDelete,
  changeRequestItemUpdate,
} from "../../api/casp/changeRequestItem";
import { useNavigate } from "react-router-dom";
import { changeRequestStatusUpdate } from "../../api/casp/changeRequest";
import _ from "lodash";
import { withTranslation } from "react-i18next";
import UserProfile from "../../Components/casp/common/userProfile";

const MainContent = (props) => {
  const [initialReqPayload, setInitialReqPayload] = useState([]);
  const [itemPayload, setItemPayload] = useState([]);
  const [itemUpdatePayload, setItemUpdatePayload] = useState([]);
  const [itemDeletePayload, setItemDeletePayload] = useState([]);
  const [itemCreatePayload, setItemCreatePayload] = useState([]);
  const [openAlert, setOpenAlert] = useState(false);
  const [isLoadingForButtons, setIsLoadingForButtons] = useState(false);
  const navigate = useNavigate();
  const [isLoadingForSubmit, setIsLoadingForSubmit] = useState(false);
  const [isUpdated, setIsUpdated] = useState(false);
  const [trigger, setTrigger] = useState(new Date());

  useEffect(() => {
    const payload = props.changeRequestDetails?.changeRequestItems.map(
      ({ displayPayload, sections, ...rest }) => {
        return { ...rest }
    });
    setInitialReqPayload(_.cloneDeep(payload));
    setItemPayload(_.cloneDeep(payload))
  }, []);

  useEffect(() => {
    if (!_.isEqual(initialReqPayload, itemPayload)) {
      setIsUpdated(true);

      const updatedData = itemPayload.filter(
        (obj1) => initialReqPayload.find(({ id, payload }) => obj1.id === id && !_.isEqual(obj1.payload, payload) )
      );
      setItemUpdatePayload(updatedData);
      setItemCreatePayload(itemPayload.filter((x) => x?.id === undefined));

      const deletedItem = props.changeRequestDetails?.changeRequestItems.filter(
        (obj1) => {
          return !itemPayload.some((obj2) => {
            return obj1.id === obj2.id;
          });
        }
      );
      setItemDeletePayload(deletedItem);
    } else {
      setIsUpdated(false);
    }
  }, [itemPayload]);

  const handleUpdate = async () => {
    try {
      setIsLoadingForButtons(true);

      let res
      if (itemCreatePayload.length) {
        let changeRequestItemPayload = {
          projectId: props.changeRequestDetails.projectId,
          changeRequestId: props.changeRequestDetails.id,
          items: itemCreatePayload,
        };
        res = await changeRequestItemCreate(changeRequestItemPayload);
      }

      if (itemDeletePayload.length) {
        let changeRequestItemPayload = {
          projectId: props.changeRequestDetails.projectId,
          changeRequestId: props.changeRequestDetails.id,
          changeRequestItemIds: itemDeletePayload.map((value) => {
            return value.id;
          }),
        };
        res = await changeRequestItemDelete(changeRequestItemPayload);
      }

      if (itemUpdatePayload && itemUpdatePayload.length) {
        let changeRequestItemPayload = {
          projectId: props.changeRequestDetails.projectId,
          changeRequestId: props.changeRequestDetails.id,
          items: itemUpdatePayload,
        };
        res = await changeRequestItemUpdate(changeRequestItemPayload);
      }

      if (res.statusCode === 200) {
        toast.success('Change request item(s) Update successfully');
      } else {
        toast.error(res.data.message);
      }
    } catch (err) {
      toast.error(err.message);
      console.log("161=>", err);
    } finally {
      setIsLoadingForButtons(false);
      setIsUpdated(false)
      props.emit()
    }
  };

  const submitChangeRequest = async () => {
    try {
      setIsLoadingForSubmit(true);
      const res = await changeRequestStatusUpdate(
        props.changeRequestDetails.id,
        {
          projectId: props.changeRequestDetails.projectId,
        }
      );
      if (res.statusCode === 200) {
        navigate(`/project/${props.changeRequestDetails.projectId}/change-request/${props.changeRequestDetails.id}/details`)
      } else {
        toast.error(res.data.message);
      }
    } catch (err) {
      toast.error(err.message);
    } finally {
      setIsLoadingForSubmit(false);
    }
  };

  return (
    <div className="changeReqMainContent projectInfo">
      <div className="mt-3">
        {/* <Card className="customCard changeReqCard portfolio-det p-3 my-3">
          <div className="row">
            <div className="col-md-4 threeColumns fourColumnsCR">
              <div className="wrap_box wrap_porfolio">
                <h5>{props.t('Portfolio')}</h5>
                <div className="owner_detail d-flex align-items-center">
                    <div className="mx-2">
                      <div>
                        <span className="userName">
                          {props.changeRequestDetails.project.portfolioProjects[0].portfolio.name}
                        </span>{" "}
                      </div>
                    </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="wrap_box wrap_porfolio">
                <h5>{props.t('Portfolio Manager')}</h5>
                <div className="owner_detail d-flex align-items-center">
                      <UserProfile user={props.changeRequestDetails.project.portfolioProjects[0].portfolio?.assignee} avatarClassName="p-4" profileClassName="profile_picture"/>
                    <div className="mx-2">
                      <div>
                        <span className="userName">
                          {props.changeRequestDetails.project.portfolioProjects[0].portfolio.assignee?.name}
                        </span>{" "}
                      </div>
                    </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="wrap_box wrap_owner">
                <h5>{props.t('Owner')}</h5>
                <div className="owner_detail d-flex align-items-center">
                <UserProfile user={props.changeRequestDetails.project?.projectOwner} avatarClassName="p-4" profileClassName="profile_picture"/>

                  <div className="mx-2">
                    <div>
                      <span className="userName">
                        {props.changeRequestDetails.project.projectOwner.name}
                      </span>{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="wrap_box wrap_sponsor">
                <h5>{props.t('Sponsor')}</h5>
                <div className="owner_detail d-flex align-items-center">
                <UserProfile user={props.changeRequestDetails.project?.projectSponsor} avatarClassName="p-4" profileClassName="profile_picture"/>

                  <div style={{ marginLeft: "10px" }}>
                    <div>
                      <span className="userName">
                        {props.changeRequestDetails.project.projectSponsor.name}
                      </span>{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Card> */}

<Card className="customCard changeReqCard portfolio-det mb-3 viewProjectApproval">
          <div className="d-grid threeColumns fourColumnsCR">
            {/* <div className="col-md-4"> */}
              <div className="wrap_box wrap_porfolio projDetailsListing flex-column">
                {/* <h5>{props.t('Portfolio')}</h5> */}
                <div className="mainUserName d-flex">
                  <span style={{ backgroundColor: '#C9F8FF' }} className='dashboardProjectIcon'>
                    <svg width="12" height="12" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M3.33333 2V0H6V2H3.33333ZM0 3.33333V0H2.66667V3.33333H0ZM3.33333 6V2.66667H6V6H3.33333ZM0 6V4H2.66667V6H0Z" fill="#1195A9" />
                    </svg>
                  </span>&nbsp;
                  <span>{props.t('Incubator')}</span>
                </div>
                <div className="owner_detail d-flex align-items-center">
                      {/* <UserProfile user={props.changeRequestDetails.project.portfolioProjects[0].portfolio}  profileClassName="profile_picture"/> */}
                    <div className="mx-2">
                      <div>
                        <span className="userName">
                          {props.changeRequestDetails.project.portfolioProjects[0].portfolio.name}
                        </span>{" "}
                      </div>
                    </div>
                </div>
            </div>
            <div className="wrap_box wrap_porfolio projDetailsListing flex-column">
                <div className="mainUserName d-flex">
                  <span style={{ backgroundColor: '#C9F8FF' }} className='dashboardProjectIcon'>
                  <svg width="12" height="12" viewBox="0 0 7 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M3.5 3C3.0875 3 2.73438 2.85313 2.44063 2.55938C2.14688 2.26562 2 1.9125 2 1.5C2 1.0875 2.14688 0.734375 2.44063 0.440625C2.73438 0.146875 3.0875 0 3.5 0C3.9125 0 4.26562 0.146875 4.55937 0.440625C4.85313 0.734375 5 1.0875 5 1.5C5 1.9125 4.85313 2.26562 4.55937 2.55938C4.26562 2.85313 3.9125 3 3.5 3ZM0.5 6V4.95C0.5 4.7375 0.554688 4.54219 0.664063 4.36406C0.773438 4.18594 0.91875 4.05 1.1 3.95625C1.4875 3.7625 1.88125 3.61719 2.28125 3.52031C2.68125 3.42344 3.0875 3.375 3.5 3.375C3.9125 3.375 4.31875 3.42344 4.71875 3.52031C5.11875 3.61719 5.5125 3.7625 5.9 3.95625C6.08125 4.05 6.22656 4.18594 6.33594 4.36406C6.44531 4.54219 6.5 4.7375 6.5 4.95V6H0.5Z" fill="#803DD7" />
                    </svg>
                  </span>&nbsp;
                  <span>{props.t('Manager')}</span>
                </div>
                <div className="owner_detail d-flex align-items-center mt-1">
                  <UserProfile user={props.changeRequestDetails.project.portfolioProjects[0].portfolio.assignee} />
                  <div className="mx-2">
                    <div>
                      <span className="userName">
                        {props.changeRequestDetails.project.portfolioProjects[0].portfolio?.assignee?.name}
                      </span>{" "}
                    </div>
                  </div>
                </div>
              </div>
            {/* <div className="col-md-4"> */}
              <div className="wrap_box wrap_owner projDetailsListing flex-column">
                {/* <h5>{props.t('Owner')}</h5> */}
                <div className="mainUserName d-flex">
                  <span style={{ backgroundColor: '#E5D1FF' }} className='dashboardProjectIcon'>
                    <svg width="12" height="12" viewBox="0 0 7 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M3.5 3C3.0875 3 2.73438 2.85313 2.44063 2.55938C2.14688 2.26562 2 1.9125 2 1.5C2 1.0875 2.14688 0.734375 2.44063 0.440625C2.73438 0.146875 3.0875 0 3.5 0C3.9125 0 4.26562 0.146875 4.55937 0.440625C4.85313 0.734375 5 1.0875 5 1.5C5 1.9125 4.85313 2.26562 4.55937 2.55938C4.26562 2.85313 3.9125 3 3.5 3ZM0.5 6V4.95C0.5 4.7375 0.554688 4.54219 0.664063 4.36406C0.773438 4.18594 0.91875 4.05 1.1 3.95625C1.4875 3.7625 1.88125 3.61719 2.28125 3.52031C2.68125 3.42344 3.0875 3.375 3.5 3.375C3.9125 3.375 4.31875 3.42344 4.71875 3.52031C5.11875 3.61719 5.5125 3.7625 5.9 3.95625C6.08125 4.05 6.22656 4.18594 6.33594 4.36406C6.44531 4.54219 6.5 4.7375 6.5 4.95V6H0.5Z" fill="#803DD7" />
                    </svg>
                  </span>&nbsp;
                  <span>{props.t('Owner')}</span>
                </div>
                <div className="owner_detail d-flex align-items-center mt-1">
                  <UserProfile user={props.changeRequestDetails.project?.projectOwner} />
                  <div className="mx-2">
                    <div>
                      <span className="userName">
                        {props.changeRequestDetails.project.projectOwner.name}
                      </span>{" "}
                    </div>
                  </div>
                </div>
              </div>
            {/* </div> */}
            {/* <div className="col-md-3"> */}
              <div className="wrap_box wrap_sponsor projDetailsListing flex-column">
                {/* <h5>{props.t('Sponsor')}</h5> */}
                <div className="mainUserName d-flex">
                  <span style={{ backgroundColor: '#D6FFAD' }} className='dashboardProjectIcon'>
                    <svg width="14" height="12" viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M0.25 6V4.95C0.25 4.7375 0.30303 4.54219 0.409091 4.36406C0.515152 4.18594 0.656061 4.05 0.831818 3.95625C1.20758 3.7625 1.58939 3.61719 1.97727 3.52031C2.36515 3.42344 2.75909 3.375 3.15909 3.375C3.55909 3.375 3.95303 3.42344 4.34091 3.52031C4.72879 3.61719 5.11061 3.7625 5.48636 3.95625C5.66212 4.05 5.80303 4.18594 5.90909 4.36406C6.01515 4.54219 6.06818 4.7375 6.06818 4.95V6H0.25ZM6.79545 6V4.875C6.79545 4.6 6.72121 4.33594 6.57273 4.08281C6.42424 3.82969 6.21364 3.6125 5.94091 3.43125C6.25 3.46875 6.54091 3.53281 6.81364 3.62344C7.08636 3.71406 7.34091 3.825 7.57727 3.95625C7.79545 4.08125 7.96212 4.22031 8.07727 4.37344C8.19242 4.52656 8.25 4.69375 8.25 4.875V6H6.79545ZM3.15909 3C2.75909 3 2.41667 2.85313 2.13182 2.55938C1.84697 2.26562 1.70455 1.9125 1.70455 1.5C1.70455 1.0875 1.84697 0.734375 2.13182 0.440625C2.41667 0.146875 2.75909 0 3.15909 0C3.55909 0 3.90152 0.146875 4.18636 0.440625C4.47121 0.734375 4.61364 1.0875 4.61364 1.5C4.61364 1.9125 4.47121 2.26562 4.18636 2.55938C3.90152 2.85313 3.55909 3 3.15909 3ZM6.79545 1.5C6.79545 1.9125 6.65303 2.26562 6.36818 2.55938C6.08333 2.85313 5.74091 3 5.34091 3C5.27424 3 5.18939 2.99219 5.08636 2.97656C4.98333 2.96094 4.89849 2.94375 4.83182 2.925C4.99545 2.725 5.12121 2.50312 5.20909 2.25938C5.29697 2.01562 5.34091 1.7625 5.34091 1.5C5.34091 1.2375 5.29697 0.984375 5.20909 0.740625C5.12121 0.496875 4.99545 0.275 4.83182 0.075C4.91667 0.04375 5.00152 0.0234375 5.08636 0.0140625C5.17121 0.0046875 5.25606 0 5.34091 0C5.74091 0 6.08333 0.146875 6.36818 0.440625C6.65303 0.734375 6.79545 1.0875 6.79545 1.5Z" fill="#4E9903" />
                    </svg>
                  </span>&nbsp;
                  <span>{props.t('Sponsor')}</span>
                </div>
                <div className="owner_detail d-flex align-items-center mt-1">
                  <UserProfile user={props.changeRequestDetails.project?.projectSponsor}/>
                  <div style={{ marginLeft: "10px" }}>
                    <div>
                      <span className="userName">
                        {props.changeRequestDetails.project.projectSponsor.name}
                      </span>{" "}
                    </div>
                  </div>
                </div>
              </div>
            {/* </div> */}
          </div>
        </Card>

        <ChangeRequestMeta
          setChangeRequestMetaInfo={props.changeRequestDetails}
        />

        {/* Select Module area starts */}
        {initialReqPayload.length && itemPayload.length &&
          <Card className="customCard changeReqCard my-3">
            <div className="allModules p-3">
              <div className="allModuleHeading">{props.t('Select Module')}</div>
              <ChangeRequestAccordion
                key={trigger}
                changeRequestDetails={props.changeRequestDetails}
                setItemPayload={setItemPayload}
              />
            </div>
          </Card>
        }

        <div className="changeRequestActions d-flex justify-content-center">
          <Button
            className="create_req_cancel"
            variant="outlined"
            onClick={() => {
              setOpenAlert(true);
            }}
          >
            {props.t('Cancel')}
          </Button>
          <Button
            className={`mx-3 ${
              !isUpdated || isLoadingForButtons
                ? "btn create_req_theme"
                : "create_req_theme"
            }`}
            variant="outlined"
            disabled={!isUpdated || isLoadingForButtons}
            onClick={() => handleUpdate()}
          >
            {isLoadingForButtons && (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                className="me-1"
              />
            )}
            {props.t('Update Module')}
          </Button>
          <Button
            disableElevation
            variant="contained"
            className={`${
              isUpdated || isLoadingForSubmit
                ? "btn btn-outline-secondary"
                : "create_req_success"
            }`}
            disabled={isUpdated || isLoadingForSubmit}
            onClick={submitChangeRequest}
          >
            {isLoadingForSubmit && (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                className="me-1"
              />
            )}
            {props.t('Submit')}
          </Button>
        </div>
      </div>
      {openAlert && (
        <SweetAlert
          title="Any unsaved changes will be discard, Do you want to continue ?"
          warning
          showCancel
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          onConfirm={() => {
            setOpenAlert(false);
            setItemPayload(initialReqPayload);
            setTrigger(+ new Date())
          }}
          onCancel={() => {
            setOpenAlert(false);
          }}
        ></SweetAlert>
      )}
    </div>
  );
}

export default withTranslation() (MainContent)
